import React from "react";

class CheckBox extends React.Component {

  render() {
    const { name, filterName, active } = this.props;
    if (name === 'three-quarter') {
      return (
        <div className="checkbox">
          <div className={`checkbox-name ${active ? 'active' : ''}`}>Three-quarter Light</div>
        </div>
      );
    } else if (name === 'full') {
      return (
        <div className="checkbox">
          <div className={`checkbox-name ${active ? 'active' : ''}`}>Full Light</div>
        </div>
      );
    } else if (name === 'half') {
      return (
        <div className="checkbox">
          <div className={`checkbox-name ${active ? 'active' : ''}`}>Half Light</div>
        </div>
      );
    } else if (name === 'L') {
      return (
        <div className="checkbox">
          <div className={`checkbox-name ${active ? 'active' : ''}`}>Ladder</div>
        </div>
      );
    }
    else {
      return (
        <div className="checkbox">
          <div className={`checkbox-name ${active ? 'active' : ''}`}>{name} {filterName && filterName}</div>
        </div>
      );
    }

  }
}

export default CheckBox;
